import { useRouter } from 'next/router'
import Image from 'next/image'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { webAssets } from '../../../utils/webAssets'
import { getFooterCopy } from './footerCopy'
import { normalizeLayoutPath, shouldHideLayoutElement } from './layoutElementVisibility'

const FooterLower = () => {
  const { t } = useTranslation('HomeLayout')
  const { locale, asPath } = useRouter()
  const copy = getFooterCopy(locale)
  const year = new Date().getFullYear()
  const isLandingPage = normalizeLayoutPath(asPath).startsWith('/lp')
  const hideFooterSocialLinks = shouldHideLayoutElement('footerSocialLinks', asPath)

  return (
    <div className='bg-[#0c1015] px-16 pb-16 text-white sm:px-24 lg:px-0 lg:pb-24'>
      <div className='container mx-auto border-t border-white/10 pt-16 lg:pt-24'>
        <div className='flex flex-col items-center gap-16 lg:flex-row lg:justify-between'>
          {hideFooterSocialLinks ? null : (
            <div className='order-1 flex items-center gap-16 lg:order-2'>
              <Link
                className='svg-white transition-opacity hover:opacity-80'
                rel='noreferrer'
                target='_blank'
                href='https://www.facebook.com/Smart-Caf-101772231520624/'
                aria-label='Visita la nostra pagina Facebook'
              >
                <Image
                  alt='Icona Facebook SmartCAF'
                  src={webAssets.facebookFooter}
                  width={40}
                  height={40}
                  className='h-40 w-40 lg:h-32 lg:w-32'
                />
              </Link>
              <Link
                className='svg-white transition-opacity hover:opacity-80'
                rel='noreferrer'
                target='_blank'
                href='https://www.instagram.com/smartcaf/?hl=it'
                aria-label='Visita la nostra pagina Instagram'
              >
                <Image
                  alt='Icona Instagram SmartCAF'
                  src={webAssets.instagramFooter}
                  width={40}
                  height={40}
                  className='h-40 w-40 lg:h-32 lg:w-32'
                />
              </Link>
              <Link
                className='svg-white transition-opacity hover:opacity-80'
                rel='noreferrer'
                target='_blank'
                href='https://www.linkedin.com/company/smart-caf/'
                aria-label='Visita la nostra pagina LinkedIn'
              >
                <Image
                  alt='Icona LinkedIn SmartCAF'
                  src={webAssets.linkedinFooter}
                  width={40}
                  height={40}
                  className='h-40 w-40 lg:h-32 lg:w-32'
                />
              </Link>
            </div>
          )}

          <p className='order-2 mb-0 text-center text-[12px] font-normal leading-[18px] text-[#657384] lg:order-1 lg:text-left lg:text-[14px] lg:lowercase'>
            {isLandingPage
              ? t('footer.copyright', {
                  defaultValue: copy.copyright,
                  year,
                })
              : null}
          </p>
        </div>
      </div>
    </div>
  )
}

export default FooterLower
